'use client';

import React, { createContext, useContext, ReactNode, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Character } from '@/lib/types/user';

interface RoleContextType {
  roles: Character[];
  loading: boolean;
  error: string | null;
}

const RoleContext = createContext<RoleContextType | undefined>(undefined);

export function RoleProvider({ children }: { children: ReactNode }) {
  const { user, loading: userLoading } = useAuth();
  const [roles, setRoles] = useState<Character[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('[RoleContext] User data:', user);
    console.log('[RoleContext] User loading:', userLoading);
    if (user?.myCharacters) {
      console.log('[RoleContext] Setting roles:', user.myCharacters);
      setRoles(user.myCharacters);
      setLoading(false);
      setError(null);
    } else if (!userLoading && user) {
      console.log('[RoleContext] No roles found, setting empty array');
      setRoles([]);
      setLoading(false);
      setError(null);
    }
  }, [user, userLoading]);

  const value: RoleContextType = {
    roles,
    loading,
    error,
  };

  return (
    <RoleContext.Provider value={value}>
      {children}
    </RoleContext.Provider>
  );
}

export function useRoles() {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRoles must be used within a RoleProvider');
  }
  return context;
}
